<template>
<inertia-link :href="$route('scheduler.posts.show',[postId,'edit'])">
  <div class="flex items-center px-4 py-3 border-b-2 border-smoke cursor-pointer hover:bg-gray-200">
      <MediaDisplay :mediaUrl="post.media_url" :mediaType="post.type" :format="'h-14 w-16 bg-gray-500 rounded-sm mr-3 mb-5 md:mb-0 bg-cover bg-center bg-no-repeat'"/>
      <div>
          <p><span class=" font-bold">{{postDateDay}}</span> {{postDateMonthTime}}</p>
          <span class=" text-sm font-light ">{{text | truncate(35, "...")}}</span>
      </div>
  </div>
</inertia-link>
</template>

<script>
import MediaDisplay from '@/components/scheduler/Common/MediaDisplay.vue';
import dayjs from 'dayjs';

var utc = require('dayjs/plugin/utc');
var timezone = require('dayjs/plugin/timezone');
var calendar = require('dayjs/plugin/calendar');
var updateLocale = require('dayjs/plugin/updateLocale')

dayjs.extend(utc);
dayjs.extend(calendar);
dayjs.extend(timezone);
dayjs.extend(updateLocale);

export default {
    name:"PostRow",

    components: {
        MediaDisplay
    },
    
    props: {
        date: {
            type: String,
            required:true
        },
        text: {
            type: String,
            required:true
        },
        post:{
            type: Object,
            required:true
        },
        postId:{
            type: Number,
            required:true
        }
    },
    computed: {
        currentPostDate: function() {
            if(!this.date) {
                return 'No date yet';
            }
            return dayjs(this.date).format('DD/MM/YYYY');
        },

        postDateMonthTime: function() {
            var clientTimezoneOffset = -(new Date().getTimezoneOffset()/60);
            return this.date ? dayjs(this.date).add(clientTimezoneOffset, 'hour').format('MMM D @ h:mma') : 'No date yet';
        },

        postDateDay: function() {
            var clientTimezoneOffset = -(new Date().getTimezoneOffset()/60);
            return this.date ? dayjs(this.date).add(clientTimezoneOffset, 'hour').calendar(dayjs()) : '';
        },
    },
}
</script>